import { useFormik } from 'formik'
import * as Yup from 'yup'
import { createTermo } from '../core/_requests'
import { TIPO_TERMO_LABELS, TipoTermoConsentimento } from '../core/_models'
import { ButtonType, showAlert, showError } from '../../../../../_metronic/helpers'
import {
  Button,
  FormInput,
  FormSelect,
  FormTextEditor,
  IOption,
  LoadingIndicator,
  useModal,
} from '../../../../components'

const termoSchema = Yup.object({
  tipo: Yup.object().nullable().required('Informe a quem o termo se destina'),
  titulo: Yup.string().required('O título é obrigatório'),
  versao: Yup.string()
    .matches(/^\d+(\.\d+)*$/, 'A versão deve ser no formato numérico (ex: 1.0, 2.0)')
    .required('A versão é obrigatória'),
  conteudo: Yup.string().required('O conteúdo é obrigatório'),
})

const TIPO_OPTIONS: IOption<TipoTermoConsentimento>[] = (
  Object.keys(TIPO_TERMO_LABELS) as TipoTermoConsentimento[]
).map((tipo) => ({ value: tipo, label: TIPO_TERMO_LABELS[tipo] }))

interface TermoFormModalProps {
  onSuccess: () => void
}

export const TermoFormModal: React.FC<TermoFormModalProps> = ({ onSuccess }) => {
  const { closeModal } = useModal()

  const formik = useFormik({
    initialValues: {
      tipo: TIPO_OPTIONS[0] as IOption<TipoTermoConsentimento> | null,
      titulo: '',
      versao: '',
      conteudo: '',
    },
    validationSchema: termoSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        await createTermo({ ...values, tipo: values.tipo!.value })
        showAlert({
          title: 'Sucesso!',
          text: 'Nova versão do termo cadastrada e ativada com sucesso!',
          icon: 'success',
        })
        onSuccess()
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <FormSelect
        formik={formik}
        label='Destinatário'
        name='tipo'
        options={TIPO_OPTIONS}
        className='mb-3'
        isRequired
        isClearable={false}
        infoText='Publicar uma versão nova inativa só a anterior do mesmo destinatário. Um termo de usuário novo obriga todos a registrar ciência de novo no próximo acesso.'
      />
      <FormInput
        formik={formik}
        label='Título do Termo'
        name='titulo'
        placeholder='Digite o título'
        className='mb-3'
        isRequired
      />
      <FormInput
        formik={formik}
        label='Versão'
        name='versao'
        placeholder='Ex: 1.0'
        className='mb-3'
        isRequired
      />
      <FormTextEditor
        formik={formik}
        label='Conteúdo do Termo'
        name='conteudo'
        placeholder='Digite o texto do termo...'
        className='mb-3'
        height={300}
        isRequired
      />
      <div className='d-flex justify-content-end pt-5'>
        <Button
          className='btn-secondary me-2'
          type={ButtonType.Reset}
          onClick={closeModal}
          disabled={formik.isSubmitting}
        >
          Cancelar
        </Button>
        <Button className='btn-primary' type={ButtonType.Submit} disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : 'Salvar e Ativar'}
        </Button>
      </div>
    </form>
  )
}
